import { EXTENSION_API_ROOT, API_ROOT } from './environment'
export default {
  CREATE_BOOKING: EXTENSION_API_ROOT + '/booking',
  FACILITIES: API_ROOT + '/facilities'
}
